import axios from "axios";


function UrlEncode(han) {
	var len = han.length;
	var ret = '';
	if ( len == 0 ) return ;
	for(var i = 0 ; i < len ; i++ ){
		ret += han.charCodeAt(i);
		ret += ';' ;
	}
	return ret ;
}

export async function login(login_type='giupin') {
    
    this.$root.loading = true;
    var form = new FormData();
    form.append("username", this.username);
    form.append("password", this.password);
    // form body에 사용자 입력값을 담아서 서버에 로그인 요청

    try {
        if (login_type == 'giupin') {
            var res = await axios.post(process.env.VUE_APP_API_URL + "/token", form);
            console.log(res.data.access_token);
        } else if (login_type == 'colaw') {
            res = await axios.post(process.env.VUE_APP_API_URL + "/token/colaw", form);
            // console.log(res.data.access_token);
            console.log(res)
        }
    } catch (err) {
        console.log(err.response.data);
        this.$root.loading = false;
        alert("로그인 실패");
        return;
    }
    
    // 이전 경로 가져오기
    var prevPath = sessionStorage.getItem("prevPath");
    if (res.data.access_token) {
        sessionStorage.setItem("token", res.data.access_token);
        // 이전 경로로 이동
        // 이전 경로가 없으면 홈으로 이동
        if (prevPath == null || prevPath == undefined || prevPath == "null" || prevPath == "undefined") {
            prevPath = "/admin/home";
        }
        this.$root.loading = false;
        this.$router.push(prevPath);

    } else {
        alert("로그인 실패");
        this.$root.loading = false;
    }

}


export async function tokenLoad() {
    var token = sessionStorage.getItem("token");
    return {
        headers: {
            Authorization: 'Bearer ' + token
        }
    }

}


export async function sessionCheck(role) {
    

    var token = sessionStorage.getItem("token");
    sessionStorage.setItem("prevPath", this.$route.path);
    
    if (role == 'admin') {
        // 토큰 유효성 검사
        if (token) {
            var config = await tokenLoad();
            var res = await axios.get(process.env.VUE_APP_API_URL + "/users/me", config);
            this.$root.user = res.data.user;            
            if (res.data.error) {
                alert("세션이 만료되었습니다. 다시 로그인해주세요.");
                sessionStorage.removeItem("token");            
                this.$router.push("/login");
            }
            if (res.data.role != 'admin') {
                // alert("관리자만 접근 가능합니다.");
                this.$router.push("/login");
            }
        }
        else {
            this.$router.push("/login");
        }
    }
    else {   

        if (token) {
            config = await tokenLoad();
            axios.get(process.env.VUE_APP_API_URL + "/users/me", config)
            .then(res => {
                console.log(res.data);
                return token;
            }).catch(err => {
                console.log(err);
                sessionStorage.removeItem("token");
            });
        }

        // 세션 스토리지에 저장된 토큰이 있는지 확인
        if (sessionStorage.getItem("token") == null 
            || sessionStorage.getItem("token") == undefined 
            || sessionStorage.getItem("token") == "null" 
            || sessionStorage.getItem("token") == "undefined") {
                    
            // query string에 저장된 토큰이 있는지 확인
            if (this.$route.query.token) {
                // query string에 저장된 토큰을 세션 스토리지에 저장
                this.$root.config.Authorization = 'Bearer ' + this.$route.query.token;                
            }

            // query string에 temp uuid가 있는 경우 확인
            else if (this.$route.query.client || this.$route.query.stakeholder) {
                // query string에 저장된 temp uuid를 세션 스토리지에 저장
                // 서버에 토큰 생성 요청
                var uuid = this.$route.query.client ? this.$route.query.client : this.$route.query.stakeholder;
                res = await axios.post(process.env.VUE_APP_API_URL + "/temporary-token", {uuid: uuid})            
                // 세션 스토리지에 저장
                if (res.data.access_token) {
                    this.$root.config.Authorization = 'Bearer ' + res.data.access_token;
                    sessionStorage.setItem("token", res.data.access_token);
                }
                return sessionStorage.getItem("token");
            }

            else {
                // 토큰이 없으면 로그인 페이지로 이동
                this.$router.push("/login");
            }
            
        } 
   
    
    }
    
}


export function docInfo(doc) {
    
    if (doc.in.orgCd == 'hometax') {
        if (doc.in.svcCd == "B1022") {
        return `소득금액증명.pdf`
        } else if (doc.in.svcCd == "B0005") {
        return `국세완납증명.pdf`
        } else if (doc.in.svcCd == "B0006") {
        return `납세사실증명.pdf`
        }
    } else if (doc.in.orgCd == "efamily.scourt") {
        if (doc.in.svcCd == "B0001") {
        return `기본증명서.pdf`
        } else if (doc.in.svcCd == "B0002") {
        return `가족관계증명서.pdf`
        } else if (doc.in.svcCd == "B0003") {
        return `혼인관계증명서.pdf`
        }
    } else if (doc.in.orgCd == 'gov') {
        if (doc.in.svcCd == "B0002") {
        return `주민등록등본.pdf`
        } else if (doc.in.svcCd == "B0003") {
        return `주민등록초본.pdf`
        } else if (doc.in.svcCd == 'B1001') {
        return `지방세납세증명.pdf`
        } else if (doc.in.svcCd == 'B1002') {
        return `지방세세목별납세증명.pdf`
        
        }
    }      
  }


export function downloadPDF(doc) {
    // var filename = this.docInfo(doc);
    // this.convert2PDF(doc.out.pdfBase64, filename);
    // session storage에 저장
    sessionStorage.setItem("pdfData", doc.out.pdfBase64);
    // pdf뷰어를 새창으로 열기
    window.open('/viewer', '_blank');
    
}


export async function searchCorpName(corpName) {
    
    var payload = {
        sangho: UrlEncode(corpName)
    }
    
    return new Promise((resolve) => {
        axios.post(process.env.VUE_APP_API_URL + "/api/admin/sangho/search", payload).then(res => {
            console.log(res.data);
            resolve(res.data);
        })
    })

}

export function formatPhoneNo(number) {

    // number이 undefined인 경우
    if (number == undefined) {
        return;
    }

    var regExp = /^\d{3}-\d{3,4}-\d{4}$/;
    if (regExp.test(number)) {
        return number;
    }
    else {
        // 앞에서부터 3자리, 3~4자리, 4자리로 구분
        return number.replace(/(\d{3})(\d{1,4})(\d{4})/, '$1-$2-$3');
    }

}

export function formatRegNo(number) {

    // number이 undefined인 경우
    if (number == undefined) {
        return;
    }

    var regExp = /^\d{6}-\d{7}$/;
    if (regExp.test(number)) {
        return number;
    }
    else {
        // 앞에서부터 6자리, 7자리로 구분
        return number.replace(/(\d{6})(\d{1,7})/, '$1-$2');
    }

}

export function hideRegNo(number) {

    // number이 undefined인 경우
    if (number == undefined) {
        return;
    }

    // 앞에서부터 6자리를 그대로 보이고 나머지는 *로 가리기
    return number.replace(/(\d{6})(\d{7})/, '$1-*******');

}